
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "nuxt": {
    "buildId": "ce5dffb0-a709-45a1-824c-bbf0549a4e63"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}

import cfg0 from "/home/runner/work/medicalclip-frontend/medicalclip-frontend/medicalclip-frontend/src/app.config.ts"

export default /*@__PURE__*/ defuFn(cfg0, inlineConfig)
